import * as cryptoJs from 'crypto-js';
import Cookies from "universal-cookie";

export function shuffleArray(cards) {
    return cards.map((a) => ({sort: Math.random(), value: a}))
        .sort((a, b) => a.sort - b.sort)
        .map((a) => a.value);
}

export function generateRandomString(length) {
    let text = "";
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
}

export function base64URL(string) {
    return string.toString(cryptoJs.enc.Base64)
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
}

export function generateCodeVerifier() {
    return generateRandomString(128);
}

export function generateCodeChallenge(codeVerifier) {
    return base64URL(cryptoJs.SHA256(codeVerifier))
}

export function toUpperCase( string ){
    return string[1].toUpperCase();
}

export function toCamelCase(string) {
    return string.toLowerCase().replace(/(_|-)([a-z])/g, toUpperCase );
}

export function generateURL(url, urlParams) {
    let generatedURL = url;

    if (Object.entries(urlParams).length !== 0 && urlParams.constructor === Object) {
        generatedURL += '?';
        let count = 0;

        for (let param in urlParams) {
            if (count !== 0) { generatedURL += '&'; }
            generatedURL += `${param}=${urlParams[param]}`;
            count++;
        }
    }

    return generatedURL;
}

export function formatErrorObject(object) {
    const result = Object.values(object);
    return result.join('\n');
}

export function formatErrorResponse(error) {
    let message = '';
    if (!error.response)
        return 'Unable to connect, check your network connection';

    if (error.response.data !== 'undefined' && error.response.data.errors) {
        message = formatErrorObject(error.response.data.errors);
    }
    else if (error.response.data !== 'undefined' && error.response.data.error) {
        message = error.response.data.error;
    }
    else if (error.response.data !== 'undefined' && error.response.data.message) {
        message = error.response.data.message;
    }
    else {
        message = error.message;
    }
    return message;
}

export function formatFormFieldErrorResponse(error) {
    let fieldMessages = {};
    if (error.response) {
        if (error.response.data !== 'undefined' && error.response.data.errors) {
            const {errors} = error.response.data;
            Object.keys(errors)
                .forEach(function eachKey(key) {
                    const newKey = toCamelCase(key);
                    fieldMessages[newKey] = formatErrorObject(errors[key]);
                });
        } else {
            fieldMessages = formatErrorResponse(error);
        }
    }
    else {
        fieldMessages = error.message;
    }
    return fieldMessages;
}

export function groupByKey(xs, key) {
    return xs.reduce((rv, x) => {
        // eslint-disable-next-line no-param-reassign
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
}

export const cookies = new Cookies();
